export const requireSnapshotMessages = {
  en: {
    selectedSnapshot: {
      title: 'No snapshot exists',
      description: ['Please', 'run discovery', 'or', 'load snapshot', ''],
    },
    discovery: {
      unloading: 'Selected snapshot is unloading.',
      discovering: 'Network discovery process is running.',
      loading: 'Selected snapshot is loading.',
      unknownRunningState: 'Selected snapshot is still being processed.',
      inError: 'Selected snapshot is in error state.',
      canceled: 'Selected snapshot was canceled.',
      loaded: undefined,
      unloaded: undefined,
    },
  },
};
